import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    List,
    ListItem,
    Container,
} from "@mui/material";

function QTP() {
    const [qtp, setQtp] = useState([]);

    useEffect(() => {
        axios({
            method: "GET",
            url: "/files/testing/qtp.txt",
        }).then((res) => {
            setQtp(res.data);
        });
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            <Box id="qtp" sx={{ mt: 8, mb: 6 }}>
                {/* Title */}
                <Typography
                    variant="h3"
                    align="center"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "#030366",
                        mt: 7,
                        fontSize: {
                            xs: "1.8rem",  // mobile (~h4)
                            sm: "2.2rem",  // tablet (~h3)
                            md: "2.8rem",  // laptop (~h3+)
                            lg: "3rem",    // desktop (~h2)
                        },
                    }}
                >
                    QTP
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", mt: 4 }}>
                    {qtp &&
                        qtp.map((item, index) => {
                            if (typeof item === "string") {
                                return (
                                    <Typography
                                        key={index}
                                        variant="body1"
                                        sx={{ fontFamily: "Raleway, sans-serif", textAlign: "justify", mb: 2 }}
                                    >
                                        {item}
                                    </Typography>
                                );
                            } else {
                                const key = Object.keys(item)[0];
                                const value = item[key];

                                if (Array.isArray(value)) {
                                    return (
                                        <Box key={index} sx={{ mb: 3, textAlign: "justify" }}>
                                            <Typography
                                                variant="h6"
                                                sx={{ color: "#030366", mb: 1, fontWeight: 600 }}
                                            >
                                                {key}
                                            </Typography>
                                            <List>
                                                {value.map((subItem, subIndex) => (
                                                    <ListItem
                                                        key={subIndex}
                                                        sx={{
                                                            fontFamily: "Raleway, sans-serif",
                                                            display: "list-item",
                                                            pl: 2,
                                                        }}
                                                    >
                                                        {subItem}
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Box>
                                    );
                                } else {
                                    return (
                                        <Box key={index} sx={{ mb: 3, textAlign: "justify" }}>
                                            <Typography
                                                variant="h6"
                                                sx={{ color: "#030366", mb: 1, fontWeight: 600 }}
                                            >
                                                {key}
                                            </Typography>
                                            <Typography
                                                variant="body1"
                                                sx={{ fontFamily: "Raleway, sans-serif" }}
                                            >
                                                {value}
                                            </Typography>
                                        </Box>
                                    );
                                }
                            }
                        })}
                </Box>
            </Box>
        </Container>
    );
}

export default QTP;
